// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.safariCorrection_s156aecy{position:relative;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-footer/dist/es/FooterExpansionContent/NavLinks/AppBtns.css"],"names":[],"mappings":"AAAA,2BAA2B,iBAAiB,CAAC","sourcesContent":[".safariCorrection_s156aecy{position:relative;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
